import React, { useState } from 'react';
import { MinusIcon, PlusIcon, XIcon, ImageOffIcon } from 'lucide-react';
export const CartItem = ({
  item,
  onRemove,
  onUpdateQuantity,
  onCursorChange
}) => {
  const [imageError, setImageError] = useState(false);
  const handleImageError = () => {
    setImageError(true);
  };
  return <div className="flex gap-3 glass border border-[#1a2a40]/50 rounded-lg p-3" data-id="element-1248">
      {/* Product image */}
      <div className="w-20 h-20 overflow-hidden rounded" data-id="element-1249">
        {imageError ? <div className="w-full h-full flex flex-col items-center justify-center bg-[#0a0e17] text-[#a0c0e0]" data-id="element-1250">
            <ImageOffIcon size={16} className="mb-1 text-[#6ff8f0]/50" data-id="element-1251" />
            <p className="text-[8px] font-mono text-center" data-id="element-1252">Unavailable</p>
          </div> : <img src={item.image} alt={item.name} className="w-full h-full object-cover" onError={handleImageError} onMouseEnter={() => onCursorChange('image')} onMouseLeave={() => onCursorChange('default')} data-id="element-1253" />}
      </div>
      {/* Product info */}
      <div className="flex-1" data-id="element-1254">
        <div className="flex justify-between" data-id="element-1255">
          <h4 className="text-[#e0e6f0] font-bold text-sm font-heading" onMouseEnter={() => onCursorChange('text')} onMouseLeave={() => onCursorChange('default')} data-id="element-1256">
            {item.name}
          </h4>
          <button className="text-[#a0c0e0] hover:text-[#6ff8f0] transition-colors duration-300" onClick={() => onRemove(item.id)} onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('default')} aria-label={`Remove ${item.name} from cart`} data-id="element-1257">
            <XIcon size={14} data-id="element-1258" />
          </button>
        </div>
        <p className="text-[#a0c0e0] text-xs font-mono uppercase mb-2" onMouseEnter={() => onCursorChange('text')} onMouseLeave={() => onCursorChange('default')} data-id="element-1259">
          {item.category}
        </p>
        <div className="flex justify-between items-center" data-id="element-1260">
          <div className="flex items-center" data-id="element-1261">
            <button className="w-6 h-6 flex items-center justify-center text-[#a0c0e0] hover:text-[#6ff8f0] border border-[#1a2a40] hover:border-[#6ff8f0]/50 rounded-l transition-colors duration-300" onClick={() => onUpdateQuantity(item.id, item.quantity - 1)} disabled={item.quantity <= 1} onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('default')} aria-label="Decrease quantity" data-id="element-1262">
              <MinusIcon size={12} data-id="element-1263" />
            </button>
            <span className="w-8 h-6 flex items-center justify-center bg-[#0a1018] text-[#e0e6f0] text-xs font-mono" data-id="element-1264">
              {item.quantity}
            </span>
            <button className="w-6 h-6 flex items-center justify-center text-[#a0c0e0] hover:text-[#6ff8f0] border border-[#1a2a40] hover:border-[#6ff8f0]/50 rounded-r transition-colors duration-300" onClick={() => onUpdateQuantity(item.id, item.quantity + 1)} onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('default')} aria-label="Increase quantity" data-id="element-1265">
              <PlusIcon size={12} data-id="element-1266" />
            </button>
          </div>
          <p className="text-[#6ff8f0] font-mono text-sm" onMouseEnter={() => onCursorChange('text')} onMouseLeave={() => onCursorChange('default')} data-id="element-1267">
            ${(item.price * item.quantity).toFixed(2)}
          </p>
        </div>
      </div>
    </div>;
};